<div
  #dynamicComponent
  class="dynamic-field-container"
  [class.selected]="config?.selected"
>
  <div class="dynamic-field form-input text-align">
    <div>
      <label>Comments</label>
      <p>
        Comments serve the purpose of allowing HSE Personnel and Field employees
        the ability to collaborate on form submissions
      </p>
      @for (item of comments; track trackByFn($index, item)) {
      <div>
        <div class="dynamic-field form-input comment-reply-item">
          <div class="reply-by" [innerHTML]="item?.createdBy"></div>
          <div class="reply-text" [innerHTML]="item.text"></div>
          <div
            class="reply-timestamp"
            innerHTML="At {{ item.createdAt | date: 'medium' }}"
          ></div>
          <button
            class="k-button reply-btn"
            [hidden]="isReplyingTo"
            (click)="replyToComment(item?.id)"
          >
            Reply
          </button>
        </div>
        @for (child of item?.comments || []; track trackByFn($index, child)) {
        <div>
          <div class="dynamic-field form-input comment-reply-inner-item">
            <div class="reply-by" [innerHTML]="child?.createdBy"></div>
            <div class="reply-text" [innerHTML]="child.text"></div>
            <div
              class="reply-timestamp"
              innerHTML="At {{ child.createdAt | date: 'medium' }}"
            ></div>
            <button
              class="k-button reply-btn"
              [hidden]="isReplyingTo"
              (click)="replyToComment(child?.id)"
            >
              Reply
            </button>
          </div>
          @for (grand of child?.comments || []; track trackByFn($index, grand))
          {
          <div class="dynamic-field form-input comment-reply-inner-item inner">
            <div class="reply-by" [innerHTML]="grand?.createdBy"></div>
            <div class="reply-text" [innerHTML]="grand.text"></div>
            <div
              class="reply-timestamp"
              innerHTML="At {{ grand.createdAt | date: 'medium' }}"
            ></div>
            <!-- <button class="k-button reply-btn" [hidden]="isReplyingTo" (click)="replyToComment(grand?.id)">Reply</button> -->
          </div>
          }
        </div>
        }
      </div>
      }
    </div>

    @if (isCommenting) { @if (isReplyingTo && isReplyingTo.text) {
    <div class="replying-to-container">
      <div
        class="replying-to-title"
        innerHTML="Replying to  {{ isReplyingTo.createdBy }}"
      ></div>
      <div class="replying-to-text" [innerHTML]="isReplyingTo.text"></div>
    </div>
    }
    <hr />
    <textarea
      #commentInput
      (itemSelected)="itemSelected($event)"
      (searchTerm)="searchChange($event)"
      [mentionListTemplate]="mentionListTemplate"
      [mentionConfig]="mentionConfig"
      class="k-textbox"
      [attr.minLength]="3"
      [attr.required]="true"
      [attr.name]="comment"
      [(ngModel)]="comment"
    ></textarea>
    <div class="dynamic-field form-button">
      <button
        class="k-button"
        style="width: 50%"
        (click)="showCancelConfirm = true"
      >
        Cancel
      </button>
      <button
        class="k-button k-primary"
        style="width: 50%"
        [disabled]="!isValid()"
        (click)="saveComment()"
      >
        Save
      </button>
    </div>
    } @if (!isCommenting) {
    <button class="k-button k-primary mt-5" (click)="enableCommenting()">
      Add Comment
    </button>
    } @if (config?.isFormBuilder) {
    <div
      class="form-builder-mask"
      [class.hidden]="config?.options?.hidden"
    ></div>
    }
  </div>
  @if (config?.isFormBuilder) {
  <div class="form-builder-options">
    <i class="fas fa-times ms-3 cursor-pointer c-red" (click)="delete()"></i>
    <!-- <i class="fas fa-bars ms-3 cursor-grab"></i> -->
  </div>
  }
</div>

<kendo-dialog modal fade [hidden]="!showCancelConfirm" [width]="550">
  <kendo-dialog-titlebar>
    <span>Cancel Comment</span>
  </kendo-dialog-titlebar>

  <p>Do you really want to Cancel Commenting?</p>

  <kendo-dialog-actions>
    <button class="k-button k-primary" (click)="cancelComment()">
      Yes, Cancel Commenting
    </button>
    <button class="k-button" (click)="showCancelConfirm = false">
      No, Continue Commenting
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<ng-template #mentionListTemplate let-item="item">
  <div style="display: inline-flex">
    <div>
      @if (item.Name) {
      <span class="job-name link-style">
        <label>{{ item?.Name }}</label>
      </span>
      } @if (item?.RoleName) {
      <span class="job-name link-style">
        <label>{{ item?.RoleName }}</label>
      </span>
      } @if (item?.CellPhone) {
      <div class="clearBoth">
        <div style="display: inline-block; width: 120px">
          <label>Cell Phone:</label>
        </div>
        <div style="display: inline-block">
          <label>{{ item?.CellPhone }}</label>
        </div>
      </div>
      } @if (item?.EMDesignationName) {
      <div class="clearBoth">
        <div style="display: inline-block; width: 120px">
          <label>EM Designation:</label>
        </div>
        <div style="display: inline-block">
          <label>{{ item?.EMDesignationName || 'n/a' }}</label>
        </div>
      </div>
      } @if (item?.FileClassName) {
      <div class="clearBoth">
        <div style="display: inline-block; width: 120px">
          <label>File Class:</label>
        </div>
        <div style="display: inline-block">
          <label>{{ item?.FileClassName || 'n/a' }}</label>
        </div>
      </div>
      } @if (item?.Company) {
      <div class="clearBoth">
        <div style="display: inline-block; width: 120px">
          <label>Company:</label>
        </div>
        <div style="display: inline-block">
          <label>{{ item?.Company || 'n/a' }}</label>
        </div>
      </div>
      }
    </div>
  </div>
</ng-template>
